exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wv-tag{padding:0 10px;color:#fff;border-radius:100px;text-transform:uppercase;letter-spacing:1px}.wv-tag__attention{background-color:var(--pink)}.wv-tag__info{background-color:var(--mustard)}.wv-tag__success{background-color:var(--lime)}.wv-tag__other{background-color:var(--purple)}.wv-tag__error{background-color:var(--red)}", ""]);

// exports
